import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

import { DtpRequest } from './dtp-request.component';
import { localization } from 'src/App/shared/localization/localization';
import { Markdown } from 'src/App/shared/localization/markdown-wrapper';

export interface IUploadFailedProps {
    logoId: string;
    apiUrl: string;
    errorMessage: string;
    requestReupload():void;
    onDtpSendCompleted(result: boolean, email?: string, errorMsg?: string): void;
}

export interface IUploadFailedState {
    disabled: boolean;
}

class UploadFailedComponent extends React.PureComponent<IUploadFailedProps,IUploadFailedState> {
    constructor(props: IUploadFailedProps) {
        super(props);

        this.state = {
            disabled: false
        };
    }

    private onDtpStarted(): void {
        this.setState({
            disabled: true
        });
    }

    private onDtpCompleted(res: boolean, email?: string, errorMsg?: string): void {
        this.setState({
            disabled: res
        });

        this.props.onDtpSendCompleted(res, email, errorMsg);
    }

    public render() {
        return (
            <div className="upload-failed-root">
                <div className="container">
                    <div className="row row-alert">
                        <div className="col-1 alert-triangle">
                            <FontAwesomeIcon icon={faExclamationTriangle} color={'red'} size="3x"/>
                        </div>
                        <div className="col-10">
                            <div className="error-title">
                                <b>
                                    <Markdown text={localization.uploadLoc.uploadFailed.msgFail} />
                                </b>
                            </div>
                            <div className="error-message">{this.props.errorMessage}</div>
                        </div>
                        <div className="col-1 alert-triangle">
                            <FontAwesomeIcon icon={faExclamationTriangle} color={'red'} size="3x"/>
                        </div>
                    </div>
                    <div className="row row-actions">
                        <div className="col-12">
                           <div className="send-dtp">
                                <div className="info">
                                    <Markdown text={localization.uploadLoc.uploadFailed.msgDtp} />
                                </div>
                                <div className="action">
                                    <DtpRequest logoId={this.props.logoId}
                                        apiUrl={this.props.apiUrl}
                                        onSendStarted={() => this.onDtpStarted()}
                                        onSendCompleted={(res, email, errorMsg) => this.onDtpCompleted(res, email, errorMsg)}
                                    />
                                </div>
                           </div>
                        </div>
                    </div>
                    <div className="row row-retry">
                        <div className="action">
                            <button className="main-button primary-style"
                                onClick={() => this.props.requestReupload()} 
                                disabled={this.state.disabled} >
                                <Markdown text={localization.uploadLoc.uploadFailed.btnRepeatUpload} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    
}

export const UploadFailed = (props: IUploadFailedProps) => <UploadFailedComponent {...props} />;



// WEBPACK FOOTER //
// ./src/App/logo-app/logo-upload/upload-failed.component.tsx